/**
 * @generated SignedSource<<aa7cc65087b34f55cc704ce5de309efd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FormItemParticipants_study$data = {
  readonly id: string;
  readonly participants: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly respondent: {
          readonly dId: any | null;
          readonly person: {
            readonly email: string | null;
            readonly firstName: string | null;
            readonly lastName: string | null;
          } | null;
          readonly recruit: {
            readonly isTest: boolean;
          } | null;
        };
      } | null;
    } | null>;
  } | null;
  readonly " $fragmentType": "FormItemParticipants_study";
};
export type FormItemParticipants_study$key = {
  readonly " $data"?: FormItemParticipants_study$data;
  readonly " $fragmentSpreads": FragmentRefs<"FormItemParticipants_study">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "search"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "FormItemParticipants_study",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "count"
        },
        {
          "kind": "Variable",
          "name": "respondent_Person_FirstName_Icontains",
          "variableName": "search"
        },
        {
          "kind": "Literal",
          "name": "respondent_Person_OptIn",
          "value": true
        }
      ],
      "concreteType": "ParticipantNodeConnection",
      "kind": "LinkedField",
      "name": "participants",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ParticipantNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ParticipantNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RespondentNode",
                  "kind": "LinkedField",
                  "name": "respondent",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "dId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PersonNode",
                      "kind": "LinkedField",
                      "name": "person",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "email",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastName",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitNode",
                      "kind": "LinkedField",
                      "name": "recruit",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isTest",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StudyNode",
  "abstractKey": null
};

(node as any).hash = "582622bc9148bdc8d24903f2b86fa36b";

export default node;
